import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const StyledNav = styled.div`
    display: flex;
    align-items: center;
    gap: 2rem;
    height: 100%;
    
    &.mobile {
        display: none;
    }

    @media (max-width: 900px) {
        &.desktop {
            display: none;
        }
        &.mobile {
            display: flex;
        }
    }
`

export const StyledLink = styled(Link)`
    color: white;
    font-size: 25px;
    line-height: 25px;
    text-decoration-line: none;

    &.active {
        color: #45CB39;
    }
    
    @media (max-width: 1000px) {
        font-size: 18px;
        line-height: 18px;
    }

    @media (max-width: 900px) {
        font-size: 24px;
        line-height: 30px;
        margin-bottom: 20px;
    }
`